// Webpack sets NODE_ENV environment variable when developing locally
export const isDevEnvironment = () => process.env.NODE_ENV === 'development';

export const isMobile = () => {
  // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/maxTouchPoints
  // if we have more than 0 touch points and the screen size is small, we assume the user is on a mobile device
  return window.navigator.maxTouchPoints > 0 && window.innerWidth < 768;
};
